import get from 'lodash/get';
import * as customPageActions from './../action_creators/custom_page_action_creators';
import notFoundActionCreator from '../../redux/action_creators/not_found_status_action_creator';
import CustomPageModel from '../../models/custom_page';
import log from '../../services/logger_service';

export default function fetchCustomPageAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(customPageActions.customPageLoading({}, store));
    const slug = get(params, 'params.slug') || params.path.split('/')[1];
    return CustomPageModel.fetch({ slug }, store)
      .then(function handleCustomPageModelData(customPageData) {
        dispatch(
          customPageActions.customPageLoaded(customPageData.data, store)
        );
        return true;
      })
      .catch(function handleCustomPageError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }
        dispatch(customPageActions.customPageError(err.data, store));
        return log.error(
          err,
          `Error in custom page actions, message: ${err.message}`
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/async_custom_page_actions.js